import React from 'react'
import _Input from './Input/Input'
import * as Str from './String'
import Img from 'react-image'
import Spinner from '../Spinner/Spinner'

export const Input = props => {
  const { displayAs, value, icon } = props
  const { linkType, prefix } = (displayAs && displayAs[0]) || {}
  return (
    <_Input
      {...props}
      type='url'
      icon={value && linkType ? `link` : icon}
      linkType={linkType}
      prefix={prefix}
    />
  )
}
export const Output = props => {
  if (props.displayAs && props.displayAs.type === 'FILE_PREVIEW') {
    return <Img src={props.data} style={{ maxWidth: '100%', maxHeight: '100%', height: 'auto', width: 'auto', display: 'block' }} unloader='Preview' loader={<Spinner style={{ maxHeight: '2em' }} isVisible size='xx-small' />} />
  }
  return <Str.Output {...props} />
}
